import api from '../api/api';

export function GetProductDataLibrary(productDataLibraryUrl) {
  return api.get(productDataLibraryUrl)
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to GetProductDataLibrary with ${productDataLibraryUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}




// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/DataLibrary/DataLibrary.js